import { useTranslation } from 'react-i18next'
import { IconButton } from '~/components/button/icon-button'
import NeuralNetwork from '~/components/container/neural-network'
import Text from '~/components/text/text'

export default function ErrorPage() {
	const { t } = useTranslation()
	return (
		<div className="flex h-[100dvh] flex-col justify-center p-4 max-md:pb-32">
			<NeuralNetwork />
			<div className="mx-auto flex w-full max-w-3xl flex-col gap-6 text-center">
				<Text as="h1" className="text-8xl! text-secondary">
					404
				</Text>
				<Text as="h2" className="text-3xl!">
					{t('error_page_not_found')}
				</Text>
				<Text>{t('error_instruction_check_spelling')}</Text>
				<div>
					<IconButton to="/" icon="home" text={t('action_back_to_homepage')} />
				</div>
			</div>
		</div>
	)
}
